import { Modal } from "antd";

const TermalPrint = (barcodeArray) => {
  const total = barcodeArray.length;
  let currentIndex = 0;
  const failedBarcodes = [];
  const successfulBarcodes = [];

  let statusLines = [];

  const modalInstance = Modal.info({
    title: "Barkod Yazdırılıyor",
    content: "Hazırlanıyor...",
    okButtonProps: { disabled: true },
    okText: "Tamam",
  });

  const updateModalContent = () => {
    modalInstance.update({
      content: (
        <div style={{ maxHeight: 300, overflowY: "auto" }}>
          <p>
            <strong>
              {currentIndex} / {total}
            </strong>{" "}
            barkod yazdırıldı
          </p>
          <ul style={{ paddingLeft: 20 }}>
            {statusLines.slice(-10).map((line, idx) => (
              <li key={idx}>{line}</li>
            ))}
          </ul>
        </div>
      ),
    });
  };

  const sendNext = () => {
    if (currentIndex >= total) {
      // Yazdırma tamamlandı
      modalInstance.update({
        title: "Yazdırma Tamamlandı",
        content: (
          <div style={{ maxHeight: 400, overflowY: "auto" }}>
            <p>Toplam {total} barkoddan:</p>
            <p>✅ {successfulBarcodes.length} başarıyla yazdırıldı</p>
            <ul>
              {successfulBarcodes.map((item, i) => (
                <li key={`success-${i}`}>{item.barcode}</li>
              ))}
            </ul>
            {failedBarcodes.length > 0 && (
              <>
                <p>❌ {failedBarcodes.length} yazdırılamadı:</p>
                <ul>
                  {failedBarcodes.map((item, i) => (
                    <li key={`fail-${i}`}>{item.barcode}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        ),
        okButtonProps: { disabled: false },
      });
      return;
    }

    const currentItem = barcodeArray[currentIndex];
    const ws = new WebSocket("ws://localhost:6100/service");

    ws.onopen = () => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.send(currentItem.zpl);
        statusLines.push(
          `✅ [${currentIndex + 1}] Gönderildi: ${currentItem.barcode}`
        );
        successfulBarcodes.push(currentItem);
        updateModalContent();
      }
    };

    ws.onerror = () => {
      if (!successfulBarcodes.includes(currentItem)) {
        statusLines.push(
          `❌ [${currentIndex + 1}] HATA: ${currentItem.barcode}`
        );
        failedBarcodes.push(currentItem);
      }
      updateModalContent();
    };

    ws.onclose = () => {
      currentIndex++;
      setTimeout(() => sendNext(), 500);
    };
  };

  sendNext();
};

export default TermalPrint;
